import React, { Component } from 'react';
import { Card, Form, Button, message, Space, Input } from 'antd-v5';
import './index.less';
import {
  getDoubaoPromptTemplateContentRequest,
  updateDoubaoPromptTemplateContentRequest,
} from '../../state/request/doubao';

const TEXT_AREA_STYLE = { width: 680 };
const FORM_BLOCK_GAP = { height: 32 };
const getPromptRequiredMessage = (label) => `请输入${label}`;

/** 展示顺序：V910图片识别 → V910 → 图片识别 → V2 → V1；与 templateType 对应关系保持不变 */
const PROMPT_SECTIONS = [
  {
    templateType: 5,
    fieldName: 'content5',
    label: 'V910图片识别提示词维护',
    formName: 'doubaoPromptTemplateContentFormV910Image',
    requiredMessage: '请输入V910图片识别提示词',
  },
  {
    templateType: 4,
    fieldName: 'content4',
    label: '大模型V910提示词',
    formName: 'doubaoPromptTemplateContentFormV910',
    requiredMessage: '请输入大模型V910提示词',
  },
  {
    templateType: 3,
    fieldName: 'content3',
    label: '图片识别提示词',
    formName: 'doubaoPromptTemplateContentFormV3',
    requiredMessage: '请输入图片识别提示词',
  },
  {
    templateType: 2,
    fieldName: 'content2',
    label: '大模型V2提示词',
    formName: 'doubaoPromptTemplateContentFormV2',
    requiredMessage: '请输入大模型V2提示词',
  },
  {
    templateType: 1,
    fieldName: 'content',
    label: '大模型V1提示词',
    formName: 'doubaoPromptTemplateContentForm',
    requiredMessage: '请输入大模型V1提示词',
  },
];

class LargeModelManagementPage extends Component {
  constructor(props) {
    super(props);
    this.state = { savingTemplateType: null, templateMap: {} };
    this.formRefs = PROMPT_SECTIONS.map(() => React.createRef());
    this.saveHandlers = PROMPT_SECTIONS.map(
      (cfg) => (values) => this.savePrompt(cfg.templateType, cfg.fieldName, cfg.requiredMessage, values),
    );
  }

  componentDidMount() {
    this.loadPromptTemplates();
  }

  loadPromptTemplates = async () => {
    const response = await getDoubaoPromptTemplateContentRequest();
    if (response.code !== 200) return;

    const list = response.data || [];
    const templateMap = {};
    PROMPT_SECTIONS.forEach((cfg, index) => {
      const template = list.find((item) => item.templateType === cfg.templateType);
      templateMap[cfg.templateType] = template;
      this.formRefs[index].current?.setFieldsValue({ [cfg.fieldName]: template?.content || '' });
    });
    this.setState({ templateMap });
  };

  async savePrompt(templateType, fieldName, emptyMessage, values) {
    const content = values[fieldName];
    if (!content) {
      message.error(emptyMessage);
      return;
    }
    const template = this.state.templateMap[templateType] || {};

    this.setState({ savingTemplateType: templateType });
    try {
      const response = await updateDoubaoPromptTemplateContentRequest({
        content,
        templateId: template.templateId,
        templateType,
      });
      if (response.code === 200) {
        await this.loadPromptTemplates();
        message.success('保存成功');
      }
    } catch (error) {
      message.error('保存失败');
    } finally {
      this.setState({ savingTemplateType: null });
    }
  }

  render() {
    const { savingTemplateType, templateMap } = this.state;

    return (
      <div className='large-model-management-page'>
        <div className='page-container'>
          <Card className='search-card' title='大模型管理'>
            {PROMPT_SECTIONS.map((cfg, index) => {
              const label = templateMap[cfg.templateType]?.templateName || cfg.label;
              const requiredMessage = getPromptRequiredMessage(label);
              return (
                <React.Fragment key={cfg.templateType}>
                  {index > 0 ? <div style={FORM_BLOCK_GAP} /> : null}
                  <Form
                    ref={this.formRefs[index]}
                    name={cfg.formName}
                    onFinish={this.saveHandlers[index]}
                    className='search-form'
                  >
                    <div className='prompt-form-row'>
                      <div className='prompt-form-label'>
                        <span className='prompt-form-required'>*</span>
                        {label}
                      </div>
                      <Form.Item
                        name={cfg.fieldName}
                        rules={[{ required: true, message: requiredMessage }]}
                        className='prompt-form-content'
                      >
                        <Input.TextArea
                          style={TEXT_AREA_STYLE}
                          rows={10}
                          showCount
                          placeholder={requiredMessage}
                        />
                      </Form.Item>
                      <Form.Item className='prompt-form-actions'>
                        <Space>
                          <Button
                            type='primary'
                            htmlType='submit'
                            loading={savingTemplateType === cfg.templateType}
                          >
                            保存配置
                          </Button>
                        </Space>
                      </Form.Item>
                    </div>
                  </Form>
                </React.Fragment>
              );
            })}
          </Card>
        </div>
      </div>
    );
  }
}

export default LargeModelManagementPage;
